import i18n from 'i18next';
import {
  Navigate,
} from 'react-big-calendar';
import {
  shallowEqual,
  useSelector,
  useDispatch,
} from 'react-redux';

import {
  getUiState,
} from 'web-selectors';
import { uiActions } from 'web-actions'
import {
  Button,
  Select,
  Tooltip,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

const mapState = (state) => ({
  openedTooltips: getUiState('openedTooltips')(state),
});

type Props = {
  label: string,
  clients: Array<any>,
  calendarSelectedUser: string,
  onFilter: { (value: any): void },
  onNavigate: { (date: any): void },
  onNewWorkoutClick: { (): void },
};

export default ({
  onNavigate,
  label,
  onNewWorkoutClick,
  onFilter,
  clients,
  calendarSelectedUser,
}: Props) => {
  const dispatch = useDispatch()
  const {
    openedTooltips,
  } = useSelector(mapState, shallowEqual);

  const handleNewEvent = () => {
    setTimeout(onNewWorkoutClick, 1)
  }

  return (
    <Flex
      align="center"
      justify="space-between"
      padding="10px"
    >
      <Flex align="center" spacing={40}>
        <Flex align="center" spacing={10}>
          <Button
            ghost
            circled
            appearance="primary"
            icon="fas fa-chevron-left"
            onClick={() => onNavigate(Navigate.PREVIOUS)}
          />
          <Button
            ghost
            circled
            appearance="primary"
            icon="fas fa-chevron-right"
            onClick={() => onNavigate(Navigate.NEXT)}
          />
        </Flex>
        <Text size="30px">{label}</Text>
      </Flex>
      <Tooltip
        body={i18n.t('tooltip.calendar.schedule.workout')}
        isOpen={openedTooltips.some(el => el.key === 'schedule_workout_button')}
      >
        <Button
          appearance="success"
          onClick={handleNewEvent}
        >
          {`${i18n.format(i18n.t('schedule.workout'), 'cap')}`}
        </Button>
      </Tooltip>
      <Select
        isClearable
        placeholder={`Filter By ${i18n.format(i18n.t('client'), 'cap')}`}
        value={clients.find((client => client.value === calendarSelectedUser))}
        onChange={e => (e ? onFilter(e.value) : onFilter(null))}
        options={clients}
        styles={{
          container: provided => ({
            ...provided,
            width: '200px',
            marginLeft: '20px',
            zIndex: 10,
          }),
          menu: provided => ({
            ...provided,
            marginTop: '1px',
          }),
        }}
      />
    </Flex>
  );
}
